import React from 'react';

import subAbas from './subabas';
import BarraSubAbas from '../../../components/BarraSubAbas';
import ContainerConteudo from '../../../components/ContainerConteudo';
import ListUsuers from '../../../components/ListUsers';

const ListaUsuarios: React.FC = () => {
  return (
    <>
      <BarraSubAbas subAbas={subAbas} />
      <ContainerConteudo>
        <ListUsuers />
      </ContainerConteudo>
    </>
  );
};

export default ListaUsuarios;
